import { ReactNode } from "react";
import { Route } from "react-router-dom";
import PageWrapper from "../components/layout/PageWrapper/PageWrapper";
import { RouteType } from "../@types/RouteType";
import AdminPortalRoutes from "./AdminPortalRoutes";
import DealerAdminRoutes from "./DealerAdminRoutes";
import DealerSalesRoutes from "./DealerSalesRoutes";
import RequireDealerPermission from "../guards/RequireDealerPermissions";


const generateRoute = (routes: RouteType[]): ReactNode => {
    return routes.map((route, index) => (
        route.index ? (
            <Route
                index
                path={route.path}
                element={
                    <PageWrapper>{route.element}</PageWrapper>}
                key={index}
            />
        ) : (
            <Route
                path={route.path}
                element={
                    <PageWrapper>{route.element}</PageWrapper>
                }
                key={index}
            >
                {route.child && (
                    generateRoute(route.child)
                )}
            </Route>
        )
    ));
};

const generateDealerRoutes = (routes: RouteType[]): ReactNode => {
    return routes.map((route, index) => (
        route.index ? (
            <Route key={index} element={<RequireDealerPermission route={route} />}>
                <Route
                    index
                    path={route.path}
                    element={
                        <PageWrapper>{route.element}</PageWrapper>
                    }
                />
            </Route>
        ) : (
            <Route key={index} element={<RequireDealerPermission route={route} />}>
                <Route
                    path={route.path}
                    element={
                        <PageWrapper>{route.element}</PageWrapper>
                    }>
                    {route.child && (
                        generateRoute(route.child)
                    )}
                </Route>
            </Route>
        )
    ));
}

export const AdminRoutes: ReactNode = generateRoute(AdminPortalRoutes)

export const DealerRoutes: ReactNode = generateDealerRoutes([...DealerAdminRoutes, ...DealerSalesRoutes]);


